export default {
	HELP_CENTER: 'help_center',
	TEACHER_RESOURCES: 'teacher_resources',
	WHATS_NEW: 'whats_new',
	CONTACT_US: 'contact_us',
	PERSONALIZED_NEWS: 'personalized_news',
	ONBOARDING_GUIDE: 'onboarding_guide',
}
